import 'swiper/css';
import { Container, chakra, Link } from '@chakra-ui/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { rem } from 'polished';
import { theme } from '@meritcircle/ui';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { GamesNavigation } from '@/utils/games';
import React, { useRef } from 'react';
import { FRONTEND_URL } from '@/config/urls';

type GameNavProps = { links: GamesNavigation };

export const GameNav = ({ links }: GameNavProps) => {
  const router = useRouter();
  const navRef = useRef(null);
  const containerRef = useRef(null);

  const route = router.asPath.split('?')[0];

  return (
    <Container
      px="0"
      py="lg"
      ref={containerRef}
      overflow="hidden"
      sx={{
        '.swiper-slide': {
          width: 'unset',
        },
      }}>
      <chakra.nav ref={navRef} display="flex" justifyContent={{ base: 'start', md: 'center' }}>
        <Swiper spaceBetween={0} slidesPerView={'auto'}>
          {links.map(({ path, page, label }, idx) => (
            <SwiperSlide key={page}>
              <NextLink
                key={page}
                href={`${FRONTEND_URL}/games${path ? `/${path}` : ''}`}
                passHref
                legacyBehavior>
                <Link
                  textDecoration="none"
                  whiteSpace="nowrap"
                  transition="0.2s ease-in"
                  size="h4"
                  fontSize={rem(24)}
                  fontWeight={400}
                  mr={idx == links.length - 1 ? 0 : { base: 'space.24', md: 'space.56' }}
                  color={route === `/games${path ? `/${path}` : ''}` ? 'white' : 'meltingSnow'}
                  _hover={{
                    textDecoration: 'None',
                    color: 'white',
                  }}
                  borderBottom={
                    route === `/games${path ? `/${path}` : ''}`
                      ? `1px solid ${theme.colors.lightPurple}`
                      : 'none'
                  }>
                  {label}
                </Link>
              </NextLink>
            </SwiperSlide>
          ))}
        </Swiper>
      </chakra.nav>
    </Container>
  );
};
